export default {"src":"/_next/static/media/rss.8cba3f14.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};